import { z } from 'zod';
import { xml2ast, allHtmlParsers } from '@utils/ast';
import { knuthShuffle } from '@utils/common';
import { baseTaskSchema } from '../schema.base.js';
import { onImageDropzoneInput } from './input.dropzone.js';

const baseTileSchema = z.object({
  itemKey: z.string().default("")
});
const audioSchema = baseTileSchema.extend({
  type: z.literal("Audio"),
  title: z.string(),
  src: z.string()
});
const imageSchema = baseTileSchema.extend({
  type: z.literal("Image"),
  title: z.string(),
  src: z.string(),
  audioSrc: z.string().nullable().default(null),
  altText: z.string().nullish().default(null)
});
const textSchema = baseTileSchema.extend({
  type: z.literal("Text"),
  text: z.string()
});
const placeItemsOnImageTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("PlaceItems"),
  answerType: z.literal("SolidItemsOnImage"),
  background: z.string(),
  backgroundAltText: z.string().nullish().default(null),
  backgroundLongDescription: z.string().nullish().default(null).transform(it => it ? xml2ast(it, allHtmlParsers, "text/html") : null),
  items: z.array(z.discriminatedUnion("type", [audioSchema, imageSchema, textSchema])),
  dropzones: z.array(onImageDropzoneInput.schema),
  settings: z.object({
    visibleDropzones: z.boolean().default(true)
  }).default({})
}).transform(({
  dropzones,
  items,
  background,
  ...rest
}) => {
  const encounteredDropzones = new Set();
  const dedupedDropzones = dropzones.filter(it => {
    const key = JSON.stringify(it);
    if (encounteredDropzones.has(key)) {
      return false;
    }
    encounteredDropzones.add(key);
    return true;
  });
  const tiles = items.map((it, index) => ({
    ...it,
    id: `${rest.id}-${index}`,
    itemKey: it.itemKey || `${rest.id}-${index}`
  }));
  return {
    ...rest,
    __orderedTiles: tiles,
    backgroundImageSrc: background,
    tiles: knuthShuffle(structuredClone(tiles)),
    content: dedupedDropzones.map((raw, index) => onImageDropzoneInput.postprocessSchemaInput(raw, {
      index,
      taskId: rest.id,
      tiles
    }))
  };
});

export { placeItemsOnImageTaskSchema };
//# sourceMappingURL=_schema.js.map
